
import { DocumentContentEditor } from "./DocumentContentEditor";

interface FinancialForecastViewProps {
  content: {
    revenueProjections?: string;
    expenseForecasts?: string;
    cashFlowProjections?: string;
    profitabilityAnalysis?: string;
  };
  documentId: string;
  onUpdate: () => void;
}

export function FinancialForecastView({ content, documentId, onUpdate }: FinancialForecastViewProps) {
  return (
    <div className="space-y-6 md:space-y-8 bg-white p-4 md:p-6 rounded-lg shadow-sm">
      <div className="border-b pb-4">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Financial Forecast</h1>
        <p className="text-sm md:text-base text-gray-600 mt-2">Comprehensive financial projections and analysis</p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-xl md:text-2xl font-semibold text-blue-600 mb-4">Revenue Projections</h2>
          <DocumentContentEditor
            section="Revenue Projections"
            content={content.revenueProjections || ""}
            documentId={documentId}
            field="revenueProjections"
            onUpdate={onUpdate}
            showHint={!content.revenueProjections}
          />
        </section>

        <section>
          <h2 className="text-xl md:text-2xl font-semibold text-blue-600 mb-4">Expense Forecasts</h2>
          <DocumentContentEditor
            section="Expense Forecasts"
            content={content.expenseForecasts || ""}
            documentId={documentId}
            field="expenseForecasts"
            onUpdate={onUpdate}
            showHint={!content.expenseForecasts}
          />
        </section>

        <section>
          <h2 className="text-xl md:text-2xl font-semibold text-blue-600 mb-4">Cash Flow Projections</h2>
          <DocumentContentEditor
            section="Cash Flow Projections"
            content={content.cashFlowProjections || ""}
            documentId={documentId}
            field="cashFlowProjections"
            onUpdate={onUpdate}
            showHint={!content.cashFlowProjections}
          />
        </section>

        <section>
          <h2 className="text-xl md:text-2xl font-semibold text-blue-600 mb-4">Profitability Analysis</h2>
          <DocumentContentEditor
            section="Profitability Analysis"
            content={content.profitabilityAnalysis || ""}
            documentId={documentId}
            field="profitabilityAnalysis"
            onUpdate={onUpdate}
            showHint={!content.profitabilityAnalysis}
          />
        </section>
      </div>
    </div>
  );
}
